import { useEffect, useState } from 'react';

import { selectFactoryUpgradeData } from '@/redux/selectors/factoryReducer';
import { selectWorkshopUpgradeData } from '@/redux/selectors/workshopSelectors';
import { useAppSelector } from '@/redux/store';

import {
  type CompateItemProps,
  type WorkshopUpgradeItemAll,
} from '../types/components';

const useFactoryUpgradedData = (id?: string): CompateItemProps[] => {
  const [isDataSaved, setIsDataSaved] = useState(false);
  const [localCompareOptions, setLocalCompaireOptions] = useState<
    CompateItemProps[]
  >([]);
  const compaireOptions = useAppSelector((state) =>
    selectFactoryUpgradeData(state, id),
  );

  useEffect(() => {
    if (!isDataSaved && compaireOptions) {
      setLocalCompaireOptions(compaireOptions);
      setIsDataSaved(true);
    }
  }, [compaireOptions, isDataSaved]);

  return localCompareOptions;
};

const useWorkshopUpgradedData = (
  id?: string,
): WorkshopUpgradeItemAll | undefined => {
  const [isDataSaved, setIsDataSaved] = useState(false);
  const [localCompareOptions, setLocalCompaireOptions] = useState<
    WorkshopUpgradeItemAll | undefined
  >(undefined);
  const compaireOptions = useAppSelector((state) =>
    selectWorkshopUpgradeData(state, id),
  );

  useEffect(() => {
    if (!isDataSaved && compaireOptions) {
      setLocalCompaireOptions(compaireOptions);
      setIsDataSaved(true);
    }
  }, [compaireOptions, isDataSaved]);

  return localCompareOptions;
};

export { useFactoryUpgradedData, useWorkshopUpgradedData };
